import PropTypes from 'prop-types';
import React from 'react';

// ROUTES
import { useNavigate } from 'react-router-dom';

import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import useDeleteEntity from '../../Hooks/useDeleteEntity';
import Button from './Buttons/Button';
import DeleteConfirmModal from './Delete/DeleteConfirmModal';

const DeleteEntityButton = ({
    service,
    resource,
    entity,
    historyBackAfterDelete,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const leavePage = () => {
        if (historyBackAfterDelete) {
            window.history.back();
        } else {
            navigate(`/${resource}`);
        }
    };

    const {
        markedForDeletion,
        markForDeletion,
        clearMarkedForDeletion,
        confirmDelete,
        error,
        isDeleting,
    } = useDeleteEntity({
        service,
        resource,
        onSuccess: leavePage,
    });

    return (
        <div className="flex w-full justify-center">
            <Button
                name={t(`delete_${resource}`)}
                icon={faTrash}
                click={() => markForDeletion(entity)}
                classNames="flex items-center justify-center font-semibold gap-4 bg-red py-5 px-10 rounded-lg text-white text-2xl bg-opacity-90 hover:bg-opacity-100 transition-colors"
            />

            <DeleteConfirmModal
                isOpen={!!markedForDeletion}
                onRequestClose={clearMarkedForDeletion}
                onConfirm={confirmDelete}
                error={error}
                isDeleting={isDeleting}
            >
                <p>{t(`application.delete_${resource}_confirm`)}</p>
            </DeleteConfirmModal>
        </div>
    );
};

export default DeleteEntityButton;

DeleteEntityButton.propTypes = {
    /**
     * Type of service
     */
    service: PropTypes.object.isRequired,
    /**
     * Type of resource
     */
    resource: PropTypes.string.isRequired,
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
    /**
     * Type of historyBackAfterDelete
     */
    historyBackAfterDelete: PropTypes.bool,
};

DeleteEntityButton.defaultProps = {
    historyBackAfterDelete: false,
};
